import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ToastService } from 'src/app/services/toast.service';


@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(private toast: ToastService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      tap({
        next: (event: any) => {
          if (event?.body) {

            // OPTIONAL: show success only for POST/PUT/DELETE
            if (['POST', 'PUT', 'DELETE'].includes(req.method)) {
              // this.toast.success(event.body?.message || 'Operation successful');
            }
          }
        },
        error: (error: HttpErrorResponse) => {

          let errorMessage = 'Something went wrong';

          if (error.error) {
            errorMessage =
              error.error.detail ||
              error.error.title ||
              error.message;
          }

          this.toast.error(errorMessage);
        }
      })
    );
  }
}
